<script setup lang="ts">
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';
  import PosUiSettingRow from '@/components/pos-v2/ui/PosUiSettingRow.vue';
  import PosUiSettingsCard from '@/components/pos-v2/ui/PosUiSettingsCard.vue';
  import PosUiTextarea from '@/components/pos-v2/ui/PosUiTextarea.vue';
  import type { IReservationSettings } from '@/interfaces/IReservationSettings';

  const props = defineProps<{ value: IReservationSettings }>();
  const emit = defineEmits<{
    (event: 'input', value: IReservationSettings): void;
  }>();
  function policyChanged(policyText: string) {
    emit('input', { ...props.value, policyText: policyText || null });
  }
</script>

<template>
  <PosUiSettingsCard
    class="messages-settings"
    flush
    :title="$t('reservations.settings.nav.messages')"
    :description="$t('reservations.messages.description')"
  >
    <PosUiSettingRow
      stack
      :label="$t('reservations.messages.policy')"
      :hint="$t('reservations.messages.policyHint')"
      input-id="rsv-booking-policy"
    >
      <div class="policy-control">
        <PosUiTextarea
          id="rsv-booking-policy"
          :value="value.policyText"
          :placeholder="$t('reservations.messages.policyPlaceholder')"
          :rows="5"
          :maxlength="1000"
          @input="policyChanged"
        />
        <span class="character-count"
          >{{ (value.policyText || '').length }} / 1000</span
        >
      </div>
    </PosUiSettingRow>
    <template #footer>
      <div class="message-preview">
        <PosUiIcon name="message-text-outline" :size="20" />
        <p>{{ $t('reservations.messages.preview') }}</p>
      </div>
    </template>
  </PosUiSettingsCard>
</template>

<style scoped lang="scss">
  .messages-settings {
    .policy-control {
      @apply tw-flex tw-w-full tw-flex-col tw-gap-1;
    }
    .character-count {
      @apply tw-text-right tw-text-xs tw-tabular-nums tw-text-neutral-500;
    }
    .message-preview {
      @apply tw-flex tw-items-start tw-gap-3 tw-text-neutral-500;
      p {
        @apply tw-m-0 tw-text-xs tw-leading-relaxed;
      }
    }
  }
</style>
